import { getCadastroAdicional } from '@/modules/cadastros-adicionais/cadastros-adicionais-utils';

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.armazem) {
    return [false, 'Armazém é obrigatório'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === 'TOTVS') {
    return validateCamposErpTotvs(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === 'TOTVS') {
    return {
      armazem: getCadastroAdicional(cadastrosAdicionais, 'ARMAZEM') || null,
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === 'TOTVS') {
    return {
      armazem: null,
    };
  }
  return {};
};
